export default function(api: GlobalFetch) {
  return async function(objectId, calendarId) {
    const requestBody = {
      displayed: 1,
      id_calendar: calendarId,
      id_object: objectId
    }
    const response = await api.fetch(
      `/api/v2/pricemulti/show`,
      {
        body: JSON.stringify(requestBody),
        method: 'POST',
      },
    )

    if (response.ok) {
      return  response.status
    } else {
      throw new Error(response.status.toString())
    }
  }
}
